// extracted by mini-css-extract-plugin
export default {"centralFlex":"style_centralFlex__JVdj5","button":"style_button__6JRYF","icon":"style_icon__Ax371"};